<template>
  <div class="vc-button-wrapper">
    <el-button
      class="f360-layout__button"
      v-bind="$attrs"
      :disabled="isLoading"
      :class="{ ...wrapperClass }"
    >
      <span class="f360-layout__button__label">
        <vc-material-icon
          :icon="icon"
          class="f360-layout__button--icon"
          v-if="icon && !isLoading"
          style="font-size: 14px"
          :style="{ color: customColor }"
        />
        <vc-material-icon
          icon="progress_activity"
          class="f360-layout__button--icon"
          :class="{ 'f360-layout__button--loading': isLoading }"
          v-if="isLoading"
          style="font-size: 14px"
          :style="{ color: customColor }"
        />
        <span v-if="label">{{ label }}</span>
        <slot></slot>
        <vc-material-icon
          :icon="suffixIcon"
          class="f360-layout__button--icon"
          v-if="suffixIcon && !isLoading && !icon"
          style="font-size: 14px"
          :style="{ color: customColor }"
        />
      </span>
    </el-button>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label?: string;
  icon?: string;
  outline?: boolean;
  filled?: boolean;
  full?: boolean;
  disabled?: boolean;
  suffixIcon?: string;
  iconSize?: string;
  size?: "small" | "default" | "large";
  base?: "default" | "neutral";
  isLoading?: boolean;
  customColor?: string;
}
import { ElButton } from 'element-plus/es/components/button/index'
import { computed } from 'vue'
const props = withDefaults(defineProps<Props>(), {
  iconSize: "16px",
  size: "default",
  type: "default",
  isLoading: false,
  suffixIcon: "",
  customColor: ""
});
const wrapperClass = computed(() => ({
  "f360-layout__button--outline": props.outline,
  "f360-layout__button--disabled": props.disabled,
  "f360-layout__button--filled": props.filled,
  "f360-layout__button--full": props.full,
  "f360-layout__button--small": props.size === "small",
  "f360-layout__button--neutral": props.base === "neutral"
}));
</script>

<style scoped lang="scss">
@use "element-plus/theme-chalk/el-button.css";
@use "@/ui/styles/variables" as *;
@use "@/ui/styles/theme/f360-theme" as *;

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.vc-button-wrapper {
  .f360-layout {
    &__button {
      height: 32px;
      width: fit-content;
      padding: 8px;
      border-radius: 5px;
      border: 1px solid #e7e7e7;
      color: $text-color;

      &__label {
        display: flex;
        align-items: center;
        gap: 8px;

        @include font-schema(14px, 500, 16px);

        &--small {
          @include font-schema(12px, 500, 12px);
        }
      }

      &--icon {
        font-size: 14px;
      }

      // Tamanho
      &--full {
        width: 100%;
      }

      &--small {
        height: 24px;
        min-height: 24px;
      }

      &--loading {
        animation: spin 2s linear infinite;
      }

      // Estados
      &--outline {
        background: transparent;
        border: none;
        color: $button-color-active;

        &:hover {
          background: $button-outline-hover;
        }
      }

      &--filled {
        background-color: $button-filled-background;
        border: none;
        color: #fff;

        &:hover {
          background: $button-filled-hover;
        }
      }

      &--neutral {
        border: 1px solid #e7e7e7;
        color: #5d5d5d;

        &:hover {
          background: #f6f6f6;
        }
      }

      &--disabled {
        background-color: #d1d1d1 !important;
        color: $button-color-disable;
        border: #d1d1d1 !important;

        &:hover {
          color: $button-color-disable;
        }

        &.f360-button {
          &--outline {
            background: transparent !important;
            border: none !important;
          }
        }
      }
    }
  }
}
</style>
